import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { templeService } from "./templeService";

export const getTemples = createAsyncThunk(
  "temple/get-temples",
  async (thunkAPI) => {
    try {
      return await templeService.getTemples();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createNewTemple = createAsyncThunk(
  "temple/create-temple",
  async (templeData, thunkAPI) => {
    try {
      return await templeService.createTemple(templeData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateATemple = createAsyncThunk(
  "temple/update-temple",
  async (templeData, thunkAPI) => {
    try {
      return await templeService.updateTemple(templeData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteATemple = createAsyncThunk(
  "temple/delete-temple",
  async (id, thunkAPI) => {
    try {
      return await templeService.deleteTemple(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getATemple = createAsyncThunk(
  "temple/get-temple",
  async (id, thunkAPI) => {
    try {
      return await templeService.getTemple(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  temples: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const templeSlice = createSlice({
  name: "temples",
  initialState,
  reducers: {
    resetState: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTemples.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTemples.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.temples = action.payload;
      })
      .addCase(getTemples.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createNewTemple.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNewTemple.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdTemple = action.payload;
      })
      .addCase(createNewTemple.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateATemple.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateATemple.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedTemple = action.payload;
      })
      .addCase(updateATemple.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteATemple.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteATemple.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedTemple = action.payload;
      })
      .addCase(deleteATemple.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getATemple.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getATemple.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.templeName = action.payload.name;
        state.templeLocation = action.payload.location;
        state.templeDeity = action.payload.deity;
        state.templeDescription = action.payload.description;
        state.templeColor = action.payload.color;
        state.templeEra = action.payload.era;
        state.templeArchitecturalStyle = action.payload.architecturalStyle;
        state.templeSignificance = action.payload.significance;
        state.templeFestivals = action.payload.festivals;
        state.templeModelFile = action.payload.modelFile;
        state.templeChantingAudio = action.payload.chantingAudio;
        state.templeIsActive = action.payload.isActive;
      })
      .addCase(getATemple.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      });
  },
});

export const { resetState } = templeSlice.actions;

export default templeSlice.reducer;